import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

const twMerge = /* __PURE__ */ extendTailwindMerge({})

export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs))
}
